import { useParams } from 'react-router-dom';
import { Col, Row } from 'antd';

import { refetchSnapDetailsAction, updateSnapBooleanStatusesSuccessAction } from 'containers/Snaps/Snap/store';
import { MilesText, Status } from 'components';

import { usePutRequest } from 'hooks';
import { getFormattedDate } from 'utils';

import { SnapClaimUnflagRequest, SnapDisplayComment } from 'codegen';

import { ConfirmButton } from './ConfirmButton';
import { DeclineButton } from './DeclineButton';

export const Claim = ({ comment, refetchComments }: { comment: SnapDisplayComment; refetchComments: () => void; }) => {
  const { snapId } = useParams();

  const [handleClaim, { loading }] = usePutRequest<unknown, SnapClaimUnflagRequest>({
    url: `/snaps/${snapId}/claims`,
    options: {
      onSuccess: () => {
        refetchComments();
        refetchSnapDetailsAction();
        updateSnapBooleanStatusesSuccessAction({ isRequiresTroubleshooting: false });
      },
    },
  });

  const commentTime = getFormattedDate(comment.createdAt, 'MMMM D, YYYY hh:mm A');

  return (
    <div className='bg-[#FAFAFA] px-[20px] py-[15px]'>
      <Row className='mb-2' gutter={4}>
        <Col>
          <MilesText
            size='sm'
            color='#707683'
          >
            {commentTime}
          </MilesText>
        </Col>
        <Col>
          <MilesText
            size='sm'
            color='#707683'
          >
            Claim ID:
            {' '}
            {comment.referenceCode}
          </MilesText>
        </Col>
      </Row>

      <Row>
        <MilesText size='md'>
          {comment.comment}
        </MilesText>
      </Row>

      <Row justify='space-between' className='mt-4'>
        <Col xs={20}>
          <Row justify='start'>
            <Col>
              {comment.resolutionStatus === SnapClaimUnflagRequest.resolutionStatus.PENDING && (
                <Row justify='end'>
                  <DeclineButton
                    loading={loading}
                    handleClaim={handleClaim}
                  />
                  <ConfirmButton
                    loading={loading}
                    handleClaim={handleClaim}
                  />
                </Row>
              )}

              {comment.resolutionReason && (
                <MilesText>
                  <strong>With comment to collector:</strong>
                  {' '}
                  {comment.resolutionReason}
                </MilesText>
              )}
            </Col>
          </Row>
        </Col>

        <Col flex={1}>
          <Row justify='end'>
            <Status status={comment.resolutionStatus} />
          </Row>
        </Col>
      </Row>
    </div>
  );
};
